module.exports = __webpack_public_path__ + "static/media/pk_light.16930182.jpg";